import * as K from './FallingQuotesConstants';
import Fuse from 'fuse.js';
import feathers from '../../../feathers';
import floopback from 'lib/floopback';
var FallingQuotes = new floopback('falling-quotes');

export function find(params) {
  return async (dispatch, getState) => {
    var _this = this;
    let FallingQuotesResults = await feathers.service('falling-quotes').find({
      query: params,
    });

    dispatch({
      type: K.FIND + '_FULFILLED',
      payload: FallingQuotesResults.data,
    });

    _this.searchTable(getState().FallingQuotes.search);
  };
}

export function findById(id) {
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND_BY_ID,
      payload: FallingQuotes.findById(id),
    });
  };
}

export function create(formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.CREATE + '_PENDING', payload: formData });
      FallingQuotes.create(formData)
        .then(function (data) {
          dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.CREATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function update(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
      FallingQuotes.update(id, formData)
        .then(function (data) {
          dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.DELETE + '_PENDING' });
      FallingQuotes.delete(id)
        .then(function (data) {
          dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.DELETE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function changeTable(feature, value) {
  return (dispatch, getState) => {
    dispatch({
      type: K.CHANGE_TABLE,
      payload: {
        feature: feature,
        value: value,
      },
    });
  };
}

export function searchTable(search) {
  return (dispatch, getState) => {
    var options = {
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['date', 'readon', 'description'],
    };

    var fuse = new Fuse(getState().FallingQuotes.data, options);
    let result = fuse.search(search);

    dispatch({
      type: K.SEARCH_TABLE,
      payload: {
        search: search,
        searchData: result,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./src/views/FallingQuotes/redux/FallingQuotesActions.jsx